import { gql } from '@apollo/client';

const customizeCarModel = {
  GET_CUSTOMIZE_CAR_MODEL: gql`
    query GetCustomizeCarModel($carId: CarId!) {
      customizeCar(carId: $carId) {
        car {
          code
          keyFeatures {
            id
            shortname
            attributes {
              disclaimer
            }
          }
          attributes {
            specDescription
          }
          model {
            attributes {
              shortname
              fullSpecsUrl
              oemcode
            }
          }
        }
      }
    }
  `,
};

export default customizeCarModel;
